import { Component, OnInit, Input, OnDestroy, HostListener, ViewChild, AfterViewInit, ChangeDetectorRef } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { SimpleModalService } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";
import { FilterNameComponent } from "./filter-name/filter-name.component";
import { ReviewService } from "./review.service";
import { take } from "rxjs/operators";
import { FilterItemReviewComponent } from "./review-card/filter-item-review/filter-item-review.component";
import { TranslateService } from "@ngx-translate/core";
@Component({
  selector: "sepidz-review",
  templateUrl: "./review.component.html",
  styleUrls: ["./review.component.scss"],
})
export class ReviewComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() hasIncludeTime: boolean = false;
  @Input() showFilter: boolean = true;
  @Input() showDateFilter: boolean = true;
  @Input() hasSavebutton: boolean = true;
  @Input() showAllDays = true;
  selectedReviewReport: any;

  @ViewChild("filterItem") filterItem: FilterItemReviewComponent;
  isFilterActive: boolean = false;

  gridClass: string = "col-md-9 col-lg-10 col-xxxl-10";
  @HostListener("window:resize", ["$event"])
  onWindowResize() {
    if (window.innerWidth < 992) this.showFilter = false;
  }
  public formGroup: UntypedFormGroup;
  constructor(
    private dialogService: SimpleModalService,
    public reviewService: ReviewService,
    private cdr: ChangeDetectorRef,
    protected translate: TranslateService
  ) {}
  ngOnInit(): void {
    this.FillData();
    if (window.innerWidth < 992) this.showFilter = false;
  }
  ngOnDestroy() {
    this.dialogService = null;
    this.reviewService = null;
    this.hasSavebutton = !this.hasSavebutton;
  }

  ngAfterViewInit() {
    this.filterItem.filterStatusChange.subscribe((status) => {
      this.isFilterActive = status;
      this.cdr.detectChanges();
    });

    this.isFilterActive = this.filterItem.isActive();
    this.cdr.detectChanges();
  }

  setValue(key: string, value: any, validator: boolean = false) {
    if (this.formGroup) {
      if (!this.formGroup.controls[key]) this.formGroup.addControl(key, new UntypedFormControl(value));
      else this.formGroup.controls[key].setValue(value);
    }
    if (validator && this.formGroup && this.formGroup.controls[key]) this.formGroup.controls[key].setValidators(Validators.required);
  }
  setShowFilter() {
    this.showFilter = !this.showFilter;
    if (this.showFilter) this.gridClass = "col-md-9 col-lg-10 col-xxxl-10";
    else this.gridClass = "col-md-12 col-lg-12 col-xxxl-12";
  }
  FillData() {
    const newGroup: any = {};
    this.formGroup = new UntypedFormGroup(newGroup);
    this.setValue("SaveFilters", null);
    this.reviewService.getReviewReport();
  }
  ShowReportTitle() {
    const filter = this.reviewService.filterSubject.getValue();
    filter.ReportKey = this.reviewService.ReportKey;
    this.dialogService
      .open(
        FilterNameComponent,
        {
          errorMessage: "NotFound!!!",
          reviewFilter: filter,
        },
        {
          closeOnClickOutside: false,
          autoFocus: true,
          closeOnEscape: true,
        }
      )
      .pipe(take(1))
      .subscribe(() => {
        this.reviewService.getReviewReport();
      });
  }
  CustomFilterChange($event) {
    this.selectedReviewReport = $event;
    this.hasSavebutton = $event;
    if ($event) this.reviewService.setReviewReport($event);
    else {
      const filter = this.reviewService.filterSubject.getValue();
      filter.items = filter.items.splice(0, 3);
      this.reviewService.filterSubject.next(filter);
    }
  }
  onClearReviewReport() {
    if (this.selectedReviewReport.Id && this.hasSavebutton) {
      this.setValue("SaveFilters", null);
      this.reviewService.deleteReviewReport(this.selectedReviewReport.Id);
      this.hasSavebutton = !this.hasSavebutton;
      setTimeout(() => {
        this.formGroup.markAsDirty();
        this.formGroup.markAllAsTouched();
      }, 500);
    }
  }
}
